/**
 * Dashboard widget identifiers
 */
export enum DASHBOARD_WIDGETS {
    BLOG = "blog",
    CALENDAR_CAPACITIES = "calendar-capacities",
    PINNED_MEMBERS = "pinned-members",
    PRIORITY_REPORT = "priority-report",
    PENDING_INCIDENTS = "pending-incidents",
}

/**
 * Dashboard column identifiers
 */
export enum DASHBOARD_COLUMNS {
    COL1 = "col1",
    COL2 = "col2",
    COL3 = "col3",
}

/**
 * Dashboard columns configuration
 */
export const DASHBOARD_COLUMNS_CONFIG = [
    { id: DASHBOARD_COLUMNS.COL1, className: "lg:col-span-4" },
    { id: DASHBOARD_COLUMNS.COL2, className: "lg:col-span-4" },
    { id: DASHBOARD_COLUMNS.COL3, className: "lg:col-span-4" },
];

/**
 * Default dashboard layout configuration
 */
export const DEFAULT_DASHBOARD_LAYOUT = {
    [DASHBOARD_COLUMNS.COL1]: [],
    [DASHBOARD_COLUMNS.COL2]: [DASHBOARD_WIDGETS.CALENDAR_CAPACITIES],
    [DASHBOARD_COLUMNS.COL3]: [
        DASHBOARD_WIDGETS.BLOG,
        DASHBOARD_WIDGETS.PRIORITY_REPORT,
        DASHBOARD_WIDGETS.PENDING_INCIDENTS,
    ],
};

/** Prefix for dashboard widget IDs that represent a pinned-members preset. */
export const PINNED_PRESET_WIDGET_PREFIX = "pinned-members-preset-";

export const getPinnedPresetWidgetKey = (presetId: string): string => `${PINNED_PRESET_WIDGET_PREFIX}${presetId}`;

/**
 * Dashboard options
 */
export enum DASHBOARD_OPTIONS {
    DASHBOARD_EDIT_MODE = "dashboard-edit-mode",
    DASHBOARD_HIDDEN_MAP = "dashboard-hidden-map",
    DASHBOARD_COLUMN_LAYOUT = "dashboard-column-layout",
}
